exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js??ref--8-oneOf-1-1!../../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../node_modules/postcss-loader/src/index.js??ref--8-oneOf-1-2!../../../../../assets/benchCss/base.scss"), "");

// module
exports.push([module.id, ".demo[data-v-0b8e8472] {\n  width: 100%;\n  height: 100%;\n}\n.demo .cbenchContent[data-v-0b8e8472] {\n    width: 100%;\n    height: calc(100% - 5vh);\n}\n", ""]);

// exports
